import styled from "styled-components";
import { colorsPalettes, setFontVariant, fonts } from "@similarweb/styles";
import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";

export const RightSide = styled.div`
    margin: 30px 30px 30px 60px;
`;
export const LeftSide = styled.div`
    background-color: ${colorsPalettes.sky[100]};
    padding: 44px 36px 25px 44px;
    width: 50%;
    position: relative;
    height: 390px;
    border-radius: 8px;
`;

export const Title = styled.div`
    ${setFontVariant("h3", colorsPalettes.carbon[500])};
    font-weight: 500;
    line-height: 24px;
`;

export const SubTitle = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
    margin: 8px 0 40px;
`;

export const BulletsTitle = styled.div`
    ${setFontVariant("listSectionTitle", colorsPalettes.carbon[400])};
    font-family: ${fonts.$dmSansFontFamily};
    margin-bottom: 12px;
`;

export const BulletContainer = styled(FlexRow)`
    align-items: center;
    margin-bottom: 15px;
`;
export const BulletText = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    font-family: ${fonts.$dmSansFontFamily};
`;
export const Bullet = styled.div`
    background-color: ${colorsPalettes.carbon[400]};
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
    flex-shrink: 0;
`;

export const TableButtonText = styled.div`
    text-decoration: underline;
    cursor: pointer;
    ${setFontVariant("input2Bold", colorsPalettes.blue[400])};
`;

export const RightSideTitleContainer = styled.div`
    width: 280px;
    margin-bottom: 20px;
`;

export const RightSideTitle = styled.span`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    margin-bottom: 20px;
    width: 200px;
    padding-right: 6px;
    font-family: ${fonts.$dmSansFontFamily};
`;

export const RightSideSubTitle = styled.span`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    font-size: 20px;
    font-weight: 700;
    font-family: ${fonts.$dmSansFontFamily};
`;

export const BillingTitle = styled.div`
    ${setFontVariant("captionTitle", colorsPalettes.carbon[400])};
    margin-bottom: 4px;
    font-family: ${fonts.$dmSansFontFamily};
`;

export const BillingMount = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
`;

export const Price = styled.div`
    font-size: 40px;
    font-weight: 700;
    line-height: 48px;
    font-family: ${fonts.$dmSansFontFamily};
    color: ${colorsPalettes.carbon[500]};
    margin-right: 6px;
`;

export const BulletsRightContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 12px;
`;

export const BulletsRightText = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    font-family: ${fonts.$dmSansFontFamily};
    margin-left: 4px;
`;

export const BulletsRightTitle = styled.div`
    ${setFontVariant("subTitle3", colorsPalettes.carbon[500])};
    font-family: ${fonts.$dmSansFontFamily};
    margin: 20px 0 12px;
`;

export const BillingMountText = styled.div`
    ${setFontVariant("subTitle3Alt", colorsPalettes.carbon[400])};
    font-weight: 500;
`;
